import {BOT_ACTION_INTERVAL_MS} from '../bots/botConfig';

/**
 * Скорость просмотра записи матча для кода ВНЕ React.
 *
 * Слайдер скорости живет в React-контексте (ReplayControlsContext) и в redux
 * сознательно не попадает — он не должен участвовать в записи и детерминизме
 * воспроизведения. Но сцене и рендереру скорость нужна: на быстрой перемотке
 * анимации не успевают прочитаться и только смазывают картину (см.
 * playUnitMovementAnimation, так же как тосты в GameToast).
 *
 * Значение держит в актуальном состоянии ReplayRunner — он единственный, кто
 * знает и множитель слайдера, и собственный шаг воспроизведения; при уходе с
 * записи оно возвращается к обычной скорости.
 */
export const DEFAULT_PLAYBACK_SPEED_MULTIPLIER = 1;

let playbackSpeedMultiplier = DEFAULT_PLAYBACK_SPEED_MULTIPLIER;

/**
 * Во сколько раз быстрее обычного темпа ходов идет запись.
 *
 * На странице записи шаг равен стандартному интервалу ходов, и множитель
 * совпадает со значением слайдера. Витрина главного меню крутит ту же запись
 * СВОИМ, укороченным шагом (см. MenuDemoGame) — там ускорение прячется в
 * интервале, и без пересчета витрина считалась бы идущей на обычной скорости.
 *
 * @param {number} actionIntervalMs — шаг воспроизведения
 * @param {number} [speedMultiplier] — множитель слайдера
 * @returns {number}
 */
export const resolvePlaybackSpeedMultiplier = (actionIntervalMs, speedMultiplier = 1) => {
  const speed = Number(speedMultiplier) > 0 ? Number(speedMultiplier) : DEFAULT_PLAYBACK_SPEED_MULTIPLIER;
  const intervalMs = Number(actionIntervalMs);
  if (!Number.isFinite(intervalMs) || intervalMs <= 0) {
    return speed;
  }

  return (BOT_ACTION_INTERVAL_MS / intervalMs) * speed;
};

export const setReplayPlaybackSpeedMultiplier = (value) => {
  playbackSpeedMultiplier = Number.isFinite(value) && value > 0
    ? value
    : DEFAULT_PLAYBACK_SPEED_MULTIPLIER;
};

export const getReplayPlaybackSpeedMultiplier = () => playbackSpeedMultiplier;

let isRewinding = false;

/**
 * Идет ли перемотка записи: «шаг назад» сбрасывает партию к началу и заново
 * прогоняет всю историю одним синхронным проходом, в обход обертки эффектов
 * (см. ReplayRunner.fastForwardTo). Анимациям, которые запускаются не из этой
 * обертки, а из middleware стора (удары ближнего боя — см.
 * meleeAnimationMiddleware), перемотку иначе не отличить от обычного шага:
 * они отыграли бы давно прошедшие бои со звуком.
 *
 * Как и скорость просмотра, признак живет в модуле, а не в redux: это
 * состояние проигрывателя, а не партии.
 */
export const setReplayRewinding = (value) => {
  isRewinding = Boolean(value);
};

export const checkIfReplayRewinding = () => isRewinding;
